import { z } from "zod";
import { IdType } from "./base.validator";
import { createdUser } from "./users.validator";

export const createdDepartment = z.object({
    id: IdType,
    departmentName: z.string(),
    accountId: IdType,

    headUser: createdUser
        .pick({ id: true, firstName: true, lastName: true })
        .nullable(),
});
export type CreatedDepartment = z.infer<typeof createdDepartment>

export const manyCreatedDepartments = z.object({
    departments: createdDepartment.array(),
});
export type ManyCreatedDepartments = z.infer<typeof manyCreatedDepartments>

export const upsertDepartmentInput = z.object({
    id: IdType.optional(),
    departmentName: z.string(),
    headId: IdType.optional(),
});
export type UpsertDepartmentInput = z.infer<typeof upsertDepartmentInput>
